<template>
  <div>
    <vue-headful title="Eftirlæti | bilaskra.is"/>
    <div class="favorites-content notifications-wrap results-cards-wrap">
      <div class="container">
        <h1 class="favorites-header-title">Eftirlæti</h1>
        <div class="favorites-header">
          <div class="favorites-header-description">
            Hér geymir þú leitarniðurstöður sem þú vilt skoða nánar eða hafa í verðvakt.
          </div>
          <div class="favorites-header-actions">

            <div class="favorites-header-notification-wrap">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 29 29" width="29px" height="29px">
                <g fill="none" fill-rule="evenodd">
                  <circle cx="14.5" cy="14.5" r="14.5" fill="#6F9F13"/>
                  <path fill="#FFF" d="M5 8h18v13H5z"/>
                  <path fill="#6F9F13"
                        d="M5 21.0909091h18V8H5v13.0909091zm.81818182-11.43736365v-.83536363H22.1818182v.83536363L14 15.9257273 5.81818182 9.65354545zM17.078 14.5871818L22.1818182 10.682v9.0122727L17.078 14.5871818zM5.81818182 10.682l5.10545458 3.906-5.10545458 5.1087273V10.682zm10.60445458 4.4067273l5.1807272 5.184H6.39909091l5.18072729-5.1823637L14 16.9419091l2.4226364-1.8531818z"/>
                </g>
              </svg>
              <div class="favorites-header-notification-description">
                Fá senda verðbreytingar á netfangið Um leið og uppfært
              </div>
              <label for="sc4" class="switch-checkbox">
                <input @change="changeSendEmailStatus" type="checkbox" v-model="sendEmail" id="sc4"/>
                <div class="switch-checkbox-mark"></div>
              </label>
            </div>

          </div>
          <!--          <div class="favorites-header-notifications">
                      <div class="favorites-header-notification-wrap">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 29 29" width="29px" height="29px">
                          <g fill="none" fill-rule="evenodd">
                            <circle cx="14.5" cy="14.5" r="14.5" fill="#6F9F13"/>
                            <path fill="#FFF" fill-rule="nonzero"
                                  d="M20.2375 12.5751328c0-3.96376135-2.1875-5.31209-4.2333333-5.61262108 0-.02030616.0041666-.04061231.0041666-.0649797C16.0083333 6.39800062 15.5541667 6 15 6c-.5541667 0-.9916667.39800062-.9916667.89753202 0 .02436739 0 .04467354.0041667.0649797-2.05.30459231-4.25 1.65698219-4.25 5.62074348C9.7625 17.204936 8.58333333 17.7004061 7 19h16c-1.575-1.3036551-2.7625-1.8031865-2.7625-6.4248672zM15 21c2.073501 0 3.7756286-.4627907 4-1h-8c.2166344.5372093 1.926499 1 4 1z"/>
                          </g>
                        </svg>
                        <div class="favorites-header-notification-description">
                          Fá tilkynningu í tölvupósti
                          <br/><a href="#">Fá tilkynningu strax í síma</a>
                        </div>
                        <label for="sc5" class="switch-checkbox">
                          <input type="checkbox" id="sc5"/>
                          <div class="switch-checkbox-mark"></div>
                        </label>
                      </div>
                      <div class="favorites-header-notification-wrap">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 29 29" width="29px" height="29px">
                          <g fill="none" fill-rule="evenodd">
                            <circle cx="14.5" cy="14.5" r="14.5" fill="#6F9F13"/>
                            <path fill="#FFF" d="M5 8h18v13H5z"/>
                            <path fill="#6F9F13"
                                  d="M5 21.0909091h18V8H5v13.0909091zm.81818182-11.43736365v-.83536363H22.1818182v.83536363L14 15.9257273 5.81818182 9.65354545zM17.078 14.5871818L22.1818182 10.682v9.0122727L17.078 14.5871818zM5.81818182 10.682l5.10545458 3.906-5.10545458 5.1087273V10.682zm10.60445458 4.4067273l5.1807272 5.184H6.39909091l5.18072729-5.1823637L14 16.9419091l2.4226364-1.8531818z"/>
                          </g>
                        </svg>
                        <div class="favorites-header-notification-description">
                          Push notifications
                          <br/><a href="#">Fá tilkynningu strax í síma</a>
                        </div>
                        <label for="sc4" class="switch-checkbox">
                          <input type="checkbox" id="sc4"/>
                          <div class="switch-checkbox-mark"></div>
                        </label>
                      </div>
                    </div>-->
        </div>

        <template v-for="(v,i) in favorites">
          <h2 class="favorites-title" style="font-size: 22px; font-weight: bold;" v-text="v.title"></h2>
          <div class="favorites-content" :key="i">
            <car v-for="(val, index) in v.data"
                 :key="index"
                 :car="val"
                 :index="index"
            />
          </div>
        </template>


      </div>
    </div>
    <Footer class="favorites-footer" v-if="isIosApp" />
  </div>
</template>

<script>
import Car from "../components/global/Car.vue";
import globalNewCar from "../helpers/globalNewCar";
import oldCars from "@/mixins/oldCars";
import {mapActions, mapMutations, mapGetters} from "vuex";
import Footer from "@/components/Footer";

export default {
  data: function () {
    return {
      sendEmail: false,
    };
  },
  mixins: [
    oldCars
  ],
  components: {
    car: Car,
    Footer
  },
  methods: {
    setEmailCheckbox() {
      this.sendEmail = !this.sendEmail;
    },
    ...mapMutations({
      setPopup: 'SET_POPUP'
    }),
    ...mapActions({
      getFav: 'GET_FAVORITES',
      manageNotifications:'MANAGE_NOTIFICATIONS',
      getProfile: 'GET_PROFILE'
    }),
    changeSendEmailStatus() {
      this.manageNotifications({notify_via_email: this.sendEmail ? 1 : 0});
    },
    convertImg(e) {
      let imageUrl = this.$store.state.imageUrl;

      if (e.thumbnail === null) {
        e.thumbnail = `${imageUrl}/images/bilaumbod-front-page.png`;
      } else {
        e.thumbnail = globalNewCar.getPicUrl(e.thumbnail);
      }
      return e;
    }
  },
  computed: {
    ...mapGetters(["isIosApp"]),
    favData() {
      return this.$store.state.favorites ? this.$store.state.favorites : [];
    },
    oldCars() {
      return this.favData.old_cars && this.favData.old_cars.map(el => this.convertCar(el));
    },
    newCars() {
      return this.favData.new_cars && this.favData.new_cars.filter(e => e.status == 1).map(e => this.convertImg(e));
    },
    stockCars() {
      return this.favData.new_cars && this.favData.new_cars.filter(e => e.status == 2).map(e => this.convertImg(e));
    },
    favorites() {
      let res = [];

      if (this.oldCars && this.oldCars.length > 0) {
        res.push({
          title: 'Notaðir bílar',
          data: this.oldCars
        });
      }

      if (this.newCars && this.newCars.length > 0) {
        res.push({
          title: 'Nýir bílar',
          data: this.newCars
        });
      }

      if (this.stockCars && this.stockCars.length > 0 && this.$store.state.showCarsInStock) {
        res.push({
          title: 'Kjarabílar',
          data: this.stockCars
        });
      }
      return res;
    }
  },
  watch: {
    '$store.state.profile.user': function () {
      if (this.$store.state.profile.user) {
        this.getFav().then(() => {
          this.sendEmail = this.$store.state.favorites.notify_via_email;
        });
      }
    },
  },
  mounted() {
    this.getProfile()
        .then(() => {
          console.log("getProfile",this.$store.state.profile.user)
          if (!this.$store.state.profile.user) {
            this.setPopup('sign-in');
          }
        });
    this.getFav().then(() => {
      this.sendEmail = this.$store.state.favorites.notify_via_email;
    });
  }
};
</script>
